"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1459],{

/***/ 7934:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ DeleteFavorite; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8356);
/* harmony import */ var _xstyled_styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4337);
/* harmony import */ var _Icons_SingleProduct__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3814);




function DeleteFavorite(param) {
    var onClick = param.onClick;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(___WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        display: "flex",
        spaceX: "0.5rem",
        whiteSpace: "nowrap",
        onClick: onClick,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                role: "img",
                "aria-label": "Trash bin",
                children: _Icons_SingleProduct__WEBPACK_IMPORTED_MODULE_2__/* .Bin */ .Dl
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_xstyled_styled_components__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xuv, {
                as: "span",
                fontSize: "14px",
                color: "gray-200",
                display: {
                    _: "inline-block",
                    desktop: "none"
                },
                children: "Eemalda"
            })
        ]
    });
};


/***/ }),

/***/ 3814:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dl": function() { return /* binding */ Bin; },
/* harmony export */   "ei": function() { return /* binding */ DeliveryTruck; }
/* harmony export */ });
/* unused harmony export GreenProduct */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);

var DeliveryTruck = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "27.551",
    height: "21.202",
    viewBox: "0 0 27.551 21.202",
    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
        id: "Group_210",
        "data-name": "Group 210",
        transform: "translate(-1008 -1011)",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                id: "Path_143",
                "data-name": "Path 143",
                d: "M1017.158,1028.816h7.5v-16.161a1.158,1.158,0,0,0-1.154-1.154h-13.853a1.158,1.158,0,0,0-1.154,1.154v16.161h2.886",
                fill: "none",
                stroke: "#a2a4be",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "1"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                id: "Path_144",
                "data-name": "Path 144",
                d: "M1031.158,1027.89h1.732V1024.5a1.155,1.155,0,0,0-.438-.9l-3.025-1.478-.519-3.59a1.142,1.142,0,0,0-1.143-1.027H1022.5v10.39h2.886",
                transform: "translate(2.161 0.926)",
                fill: "none",
                stroke: "#a2a4be",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "1"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                id: "Ellipse_22",
                "data-name": "Ellipse 22",
                cx: "2.886",
                cy: "2.886",
                r: "2.886",
                transform: "translate(1027.547 1025.93)",
                fill: "none",
                stroke: "#a2a4be",
                strokeLinecap: "round",
                strokeMiterlimit: "10",
                strokeWidth: "1"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                id: "Ellipse_23",
                "data-name": "Ellipse 23",
                cx: "2.886",
                cy: "2.886",
                r: "2.886",
                transform: "translate(1011.386 1025.93)",
                fill: "none",
                stroke: "#a2a4be",
                strokeLinecap: "round",
                strokeMiterlimit: "10",
                strokeWidth: "1"
            })
        ]
    })
});
var GreenProduct = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "21",
    height: "24",
    viewBox: "0 0 21 24",
    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
        id: "Group_346",
        "data-name": "Group 346",
        transform: "translate(-913 -192)",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                id: "Path_238",
                "data-name": "Path 238",
                d: "M925.5,194.5c0,1.1-2,4-2,4s-2-2.9-2-4a2,2,0,0,1,4,0Z",
                fill: "none",
                stroke: "#b1dfd7",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "1"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                id: "Path_239",
                "data-name": "Path 239",
                d: "M918.5,197.5c1.1,0,4,2,4,2s-2.9,2-4,2a2,2,0,0,1,0-4Z",
                fill: "none",
                stroke: "#b1dfd7",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "1"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                id: "Path_240",
                "data-name": "Path 240",
                d: "M921.5,204.5c0-1.1,2-4,2-4s2,2.9,2,4a2,2,0,0,1-4,0Z",
                fill: "none",
                stroke: "#b1dfd7",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "1"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                id: "Path_241",
                "data-name": "Path 241",
                d: "M928.5,201.5c-1.1,0-4-2-4-2s2.9-2,4-2a2,2,0,0,1,0,4Z",
                fill: "none",
                stroke: "#b1dfd7",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "1"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                id: "Path_242",
                "data-name": "Path 242",
                d: "M923.5,215.5c2-7,4-10,10-10C929.5,211.5,929.5,215.5,923.5,215.5Z",
                fill: "none",
                stroke: "#b1dfd7",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "1"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                id: "Path_243",
                "data-name": "Path 243",
                d: "M923.5,215.5c-2-7-4-10-10-10C917.5,211.5,917.5,215.5,923.5,215.5Z",
                fill: "none",
                stroke: "#b1dfd7",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "1"
            })
        ]
    })
});
var Bin = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "16.001",
    height: "19.693",
    viewBox: "0 0 16.001 19.693",
    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
        id: "Icon_metro-bin",
        "data-name": "Icon metro-bin",
        d: "M5.73,8.082V20.39A1.234,1.234,0,0,0,6.96,21.621H18.038a1.234,1.234,0,0,0,1.231-1.231V8.082H5.73ZM9.422,19.159H8.191V10.544H9.422Zm2.462,0H10.653V10.544h1.231Zm2.462,0H13.114V10.544h1.231Zm2.462,0H15.576V10.544h1.231ZM19.576,4.39h-4V2.851a.926.926,0,0,0-.923-.923H10.345a.926.926,0,0,0-.923.923V4.39h-4a.926.926,0,0,0-.923.923V6.851h16V5.313A.926.926,0,0,0,19.576,4.39Zm-5.231,0H10.653V3.174h3.692V4.39Z",
        transform: "translate(-4.499 -1.928)",
        fill: "#c5cacf"
    })
});


/***/ }),

/***/ 1459:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ MobileProductCard; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var hooks_products_useProductCardPrice__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9926);
/* harmony import */ var hooks_account_useWishlist__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3163);
/* harmony import */ var utils_getProductImage__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(7883);
/* harmony import */ var _xstyled_styled_components__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(4337);
/* harmony import */ var _DiscountPercentBadge__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4522);
/* harmony import */ var _UI_Image__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(9696);
/* harmony import */ var _UI_Primitives_FlexBox__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(5653);
/* harmony import */ var _UI_Primitives_ClientOnly__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(1028);
/* harmony import */ var _UI_Ratings_StarRating__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(9565);
/* harmony import */ var _UI_Button_AddToCart__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(5618);
/* harmony import */ var _UI_Button_DeleteFavorite__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(7934);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  position: relative;\n  display: flex;\n  align-items: center;\n  padding: 0.2rem 0.4rem 0.5rem;\n  border-radius: 12px;\n  border: 0.7px solid #d8d9e5;\n  background-color: white;\n  font-weight: 500;\n  margin-top: 2rem;\n  margin-right: 0.5rem;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  width: 80%;\n  margin-top: 1.5rem;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  font-size: 0.9rem;\n  line-height: 1.5;\n\n  @media (min-width: mobile) {\n    font-size: xsmall;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  padding: 0.4rem 1rem 0.6rem 0;\n  color: teal-200;\n  font-size: xsmall;\n\n  @media (min-width: mobile) {\n    font-size: small;\n    padding: 0.2rem 1rem 0.4rem 0;\n  }\n\n  @media (min-width: tablet) {\n    padding: 0.6rem 1rem 0.8rem 0;\n  }\n\n  span {\n    position: relative;\n    margin-right: 0.5rem;\n    font-size: xxsmall;\n    font-weight: 500;\n    color: blue-200;\n    text-decoration: line-through;\n\n    @media (min-width: mobile) {\n      font-size: xsmall;\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}













// import { CompareButtonSmall } from '@/UI/Button/Compare';

var MobileCardWrapper = _xstyled_styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"].divBox */ .ZPm.divBox(_templateObject());
var MobileCardTitle = _xstyled_styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"].p */ .ZPm.p(_templateObject1());
var MobileCardPrice = _xstyled_styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"].p */ .ZPm.p(_templateObject2());
function MobileProductCard(_param) {
    var product = _param.product, rest = _objectWithoutProperties(_param, [
        "product"
    ]);
    var ref, ref1, ref2, ref3, ref4, ref5, ref6;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    var favorites = router.pathname.endsWith("lemmikud");
    var price = (0,hooks_products_useProductCardPrice__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(product === null || product === void 0 ? void 0 : product.price_range);
    var image = (0,utils_getProductImage__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({
        mainImage: product === null || product === void 0 ? void 0 : product.image,
        gallery: product === null || product === void 0 ? void 0 : product.media_gallery
    });
    var removeFromWishlist = (0,hooks_account_useWishlist__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(product).removeFromWishlist;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(MobileCardWrapper, _objectSpread({}, rest, {
        children: [
            (price === null || price === void 0 ? void 0 : (ref = price.discount) === null || ref === void 0 ? void 0 : ref.percentNumber) > 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_DiscountPercentBadge__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                percent: "-" + Math.round(Number(price === null || price === void 0 ? void 0 : (ref1 = price.discount) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.percent) === null || ref2 === void 0 ? void 0 : ref2.replace("-", "").replace(" ", "").replace("kuni", "").replace("%", ""))) + "%"
            }) : null,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                href: "/toode/[toode]",
                as: "/toode/".concat(product === null || product === void 0 ? void 0 : product.url_key),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_UI_Image__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        src: image === null || image === void 0 ? void 0 : image.url,
                        alt: image === null || image === void 0 ? void 0 : image.label,
                        width: 190,
                        height: 200,
                        objectFit: "contain"
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_UI_Primitives_FlexBox__WEBPACK_IMPORTED_MODULE_7__/* .FlexBox */ .h, {
                dir: "column",
                w: "100%",
                position: "relative",
                left: 16,
                children: [
                    !favorites && (product === null || product === void 0 ? void 0 : product.rating_summary) > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_UI_Ratings_StarRating__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                        rating: product === null || product === void 0 ? void 0 : product.rating_summary,
                        position: "absolute",
                        right: 22,
                        top: 4,
                        spaceX: 4
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                        href: "/toode/[toode]",
                        as: "/toode/".concat(product === null || product === void 0 ? void 0 : product.url_key),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(MobileCardTitle, {
                                children: product === null || product === void 0 ? void 0 : product.name
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(MobileCardPrice, {
                        children: [
                            (price === null || price === void 0 ? void 0 : (ref3 = price.discount) === null || ref3 === void 0 ? void 0 : ref3.value) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                children: [
                                    product === null || product === void 0 ? void 0 : (ref4 = product.price_range) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.maximum_price) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.regular_price) === null || ref6 === void 0 ? void 0 : ref6.value,
                                    "\u20AC"
                                ]
                            }) : null,
                            price === null || price === void 0 ? void 0 : price.value
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_UI_Primitives_FlexBox__WEBPACK_IMPORTED_MODULE_7__/* .FlexBox */ .h, {
                        spaceX: {
                            _: "0.5rem",
                            mobile: "1rem"
                        },
                        ml: {
                            _: "-1rem",
                            mobile: "-1.2rem",
                            tablet: "-0.4rem"
                        },
                        transform: {
                            _: "scale(0.9)",
                            tablet: "scale(1)"
                        },
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_UI_Primitives_ClientOnly__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_UI_Button_AddToCart__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                    product: product
                                })
                            }),
                            favorites && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_UI_Button_DeleteFavorite__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                onClick: function() {
                                    return removeFromWishlist();
                                }
                            })
                        ]
                    })
                ]
            })
        ]
    }));
};


/***/ }),

/***/ 3163:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ useWishlist; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(4051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useMutation.js
var useMutation = __webpack_require__(319);
// EXTERNAL MODULE: ./graphql/mutations/index.js + 30 modules
var mutations = __webpack_require__(9592);
// EXTERNAL MODULE: ./hooks/account/useWishlistData.js
var useWishlistData = __webpack_require__(7532);
// EXTERNAL MODULE: ./node_modules/@xstyled/core/dist/core.esm.js
var core_esm = __webpack_require__(1278);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react-hot-toast/dist/react-hot-toast.esm.js + 1 modules
var react_hot_toast_esm = __webpack_require__(4931);
// EXTERNAL MODULE: ./node_modules/@xstyled/styled-components/dist/styled-components.esm.js
var styled_components_esm = __webpack_require__(4337);
// EXTERNAL MODULE: ./components/UI/Toast/toastStyles.js
var toastStyles = __webpack_require__(1368);
// EXTERNAL MODULE: ./components/UI/Primitives/FlexBox.js
var FlexBox = __webpack_require__(5653);
// EXTERNAL MODULE: ./components/UI/Icons/index.js
var Icons = __webpack_require__(9430);
;// CONCATENATED MODULE: ./components/UI/Toast/WishlistToast.js






function newItemInWishlistToast(param) {
    var item = param.item, action = param.action, isDesktop = param.isDesktop, lang = param.lang;
    var added = action === "add";
    return (0,react_hot_toast_esm/* default */.ZP)(function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(FlexBox/* FlexBox */.h, {
            as: "span",
            align: "center",
            spaceX: 16,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(styled_components_esm/* Box */.xuv, {
                    as: "span",
                    role: "img",
                    "aria-label": "Product ".concat(added ? "added to wishlist" : "removed from wishlist"),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* Heart */.Xd, {
                        fill: added ? "#fe93bf" : "none"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    children: [
                        lang === "et" ? "Toode" : "Product",
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                            children: item
                        }),
                        " ",
                        added ? lang === "et" ? "lisatud lemmikutesse" : "added to favourites" : lang === "et" ? "eemaldatud lemmikutest" : "removed from favourites"
                    ]
                })
            ]
        });
    }, {
        styles: (0,toastStyles/* toastStyles */.j)({
            isDesktop: isDesktop,
            background: "#FFF"
        })
    });
};

// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
;// CONCATENATED MODULE: ./hooks/account/useWishlist.js
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}







function useWishlist(product) {
    var router = (0,next_router.useRouter)();
    var lang = router.locale ? router.locale : "et";
    var viewportWidth = (0,core_esm/* useViewportWidth */.jK)();
    var isDesktop = viewportWidth >= 1024;
    var ref = (0,useWishlistData/* default */.Z)(product), id = ref.id, itemId = ref.itemId;
    var simpleProduct = (product === null || product === void 0 ? void 0 : product.__typename) === "SimpleProduct";
    var item = simpleProduct ? {
        sku: product === null || product === void 0 ? void 0 : product.sku
    } : {
        parent_sku: product === null || product === void 0 ? void 0 : product.sku,
        sku: product === null || product === void 0 ? void 0 : product.sku
    };
    var ref1 = _slicedToArray((0,useMutation/* useMutation */.D)(mutations/* ADD_TO_WISHLIST */.Cm, {
        variables: {
            id: id,
            item: _objectSpread({}, item, {
                quantity: 1
            })
        }
    }), 1), add = ref1[0];
    var ref2 = _slicedToArray((0,useMutation/* useMutation */.D)(mutations/* REMOVE_FROM_WISHLIST */.Ji, {
        variables: {
            id: id,
            itemId: itemId
        }
    }), 1), remove = ref2[0];
    var addToWishlist = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return add();
                    case 2:
                        newItemInWishlistToast({
                            item: product === null || product === void 0 ? void 0 : product.name,
                            action: "add",
                            isDesktop: isDesktop,
                            lang: lang
                        });
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function addToWishlist() {
            return _ref.apply(this, arguments);
        };
    }();
    var removeFromWishlist = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return remove();
                    case 2:
                        newItemInWishlistToast({
                            item: product === null || product === void 0 ? void 0 : product.name,
                            action: "remove",
                            isDesktop: isDesktop,
                            lang: lang
                        });
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function removeFromWishlist() {
            return _ref.apply(this, arguments);
        };
    }();
    return {
        addToWishlist: addToWishlist,
        removeFromWishlist: removeFromWishlist
    };
};


/***/ }),

/***/ 7532:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useWishlistData; }
/* harmony export */ });
/* harmony import */ var _useCustomerState__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6806);

function useWishlistData(product) {
    var ref, ref1, ref2;
    var customer = (0,_useCustomerState__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)().customer;
    var wishlists = customer === null || customer === void 0 ? void 0 : customer.wishlists;
    var wishlist = (wishlists === null || wishlists === void 0 ? void 0 : wishlists.length) > 0 && wishlists[0];
    var id = (wishlists === null || wishlists === void 0 ? void 0 : wishlists.length) === 0 ? 0 : wishlist === null || wishlist === void 0 ? void 0 : wishlist.id;
    var itemId = (ref2 = wishlist === null || wishlist === void 0 ? void 0 : (ref = wishlist.items_v2) === null || ref === void 0 ? void 0 : (ref1 = ref.items) === null || ref1 === void 0 ? void 0 : ref1.filter(function(item) {
        return item.product.sku === (product === null || product === void 0 ? void 0 : product.sku);
    })[0]) === null || ref2 === void 0 ? void 0 : ref2.id;
    return {
        id: id,
        itemId: itemId
    };
};


/***/ })

}]);